import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-search-result-card-failure',
  templateUrl: './search-result-card-failure.component.html',
  styleUrls: ['./search-result-card-failure.component.scss']
})
export class SearchResultCardFailureComponent {
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/search-results/components/search-result-card-failure/search-result-card-failure.component.ts